import { func, node, string } from 'prop-types';
import React from 'react';

const Card = ({ children, className, onClick }) => {
	return (
		<div className={className} onClick={onClick}>
			{children}
		</div>
	);
};

Card.propTypes = {
	children: node.isRequired,
	className: string,
	onClick: func
};

export default Card;
